import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { PromPayListStateData } from './types';

const initialState: PromPayListStateData = {
	data: { data: { result: [] }, error: null },
	loading: false,
	error: '',
};

export const fetchPromPayList = createAsyncThunk('api/fetchPromPayList', (sessionId: string) =>
	api.fetchPromPayList(sessionId),
);

const promPayListSlice = createSlice({
	name: 'promPayList',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchPromPayList.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchPromPayList.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchPromPayList.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default promPayListSlice.reducer;
